import React, { useMemo, useState } from "react";
import {
    ContentUkm,
    DefaultResponse,
    ErrorFieldResponse,
} from "../../constants/types";
import * as yup from "yup";
import defaultAxios, { AxiosError } from "axios";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import axios from "../../services/axios";
import Swal from "sweetalert2";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TextField from "@mui/material/TextField";
import LoadingButton from "@mui/lab/LoadingButton";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import qs from "query-string";
import { useTransaksi } from "../../context/transaksiContext";
import { useEditKategoriModal } from "../../context/editKategoriModalContext";
import { useAuth } from "../../context/authContext";
import { useKategoriModal } from "../../context/kategoriModalContext";

interface IModalUnggahKategoriProps {
    refetch: () => void;
    ukmData?: ContentUkm;
}

interface IValuesImport {
    berkas: File | null;
}

const schema = yup.object({
    berkas: yup.mixed(),
});

const ModalUnggahKategori = ({
    refetch,
    ukmData,
}: IModalUnggahKategoriProps) => {
    const theme = useTheme();
    const { setFetchingItems } = useTransaksi();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.between("xs", "sm"));
    const isDesktopScreen = useMediaQuery(theme.breakpoints.up("md"));
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [isButtonTemplateLoading, setIsButtonTemplateLoading] =
        useState(false);
    const { ukmIdUser } = useAuth();
    const { openModalKategori, openModalSubKategori } = useKategoriModal();
    const { isOpenModalUnggahKategori, closeModalUnggahKategori, isKategori } =
        useEditKategoriModal();

    const initialValues: IValuesImport = useMemo(
        () => ({
            berkas: null,
        }),
        [],
    );

    const apiUnduhTemplate = async () => {
        setIsButtonTemplateLoading(true);
        try {
            const res = await axios.get("api/importkategori", {
                responseType: "blob",
            });
            if (res.status === 200) {
                const file = new Blob([res.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
                });
                const fileURL = URL.createObjectURL(file);
                const link = document.createElement("a");
                link.href = fileURL;
                link.setAttribute(
                    "download",
                    `Template_Unggah_Kategori_${ukmData?.namaToko}`,
                ); //or any other extension
                document.body.appendChild(link);
                link.click();
                setIsButtonTemplateLoading(false);
            }
        } catch (error) {
            console.error(error);
            setIsButtonTemplateLoading(false);
        }
    };

    const apiUnduhTemplateSubKategori = async () => {
        setIsButtonTemplateLoading(true);
        try {
            const apiUrl = qs.stringifyUrl({
                url: "api/importsub",
                query: {
                    ukmId: ukmIdUser && ukmIdUser[0],
                },
            });
            const res = await axios.get(apiUrl, {
                responseType: "blob",
            });
            if (res.status === 200) {
                const file = new Blob([res.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
                });
                const fileURL = URL.createObjectURL(file);
                const link = document.createElement("a");
                link.href = fileURL;
                link.setAttribute(
                    "download",
                    `Template_Unggah_SubKategori_${ukmData?.namaToko}`,
                ); //or any other extension
                document.body.appendChild(link);
                link.click();
                setIsButtonTemplateLoading(false);
            }
        } catch (error) {
            console.error(error);
            setIsButtonTemplateLoading(false);
        }
    };

    const {
        handleSubmit,
        control,
        reset,
        setValue,
        setError,
        clearErrors,
        formState: { errors },
    } = useForm<IValuesImport>({
        resolver: yupResolver(schema),
        defaultValues: initialValues,
    });

    const onSubmit = async (values: IValuesImport) => {
        console.log(values);
        setIsButtonLoading(true);
        if (isKategori) {
            try {
                const formData = new FormData();
                formData.append("ukmId", String(ukmIdUser && ukmIdUser[0]));
                formData.append(
                    "file",
                    values.berkas ? (values.berkas as any) : "",
                );
                const { data } = await axios.post<DefaultResponse>(
                    `/api/importkategori`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );
                if (data.code === 200) {
                    Swal.fire({
                        title: "Kategori berhasil diunggah",
                        position: "top-end",
                        showConfirmButton: false,
                        icon: "success",
                        toast: true,
                        timer: 3000,
                        timerProgressBar: true,
                        showCloseButton: true,
                        customClass: {
                            container: "my-swal",
                        },
                    });
                }
                // openAlert();
                setIsButtonLoading(false);
                setFetchingItems();
                closeModalUnggahKategori();
                if (isKategori) {
                    openModalKategori();
                } else {
                    openModalSubKategori();
                }
                reset(initialValues);
                // console.log(data.nama);
            } catch (error) {
                if (defaultAxios.isAxiosError(error)) {
                    const serverError = error as AxiosError<
                        ErrorFieldResponse | undefined
                    >;
                    if (serverError && serverError?.response) {
                        Swal.fire({
                            title: `${serverError.response.data?.message}`,
                            position: "top-end",
                            showConfirmButton: false,
                            icon: "error",
                            toast: true,
                            timer: 3000,
                            timerProgressBar: true,
                            showCloseButton: true,
                            customClass: {
                                container: "my-swal",
                            },
                        });
                    }
                }
                closeModalUnggahKategori();
                if (isKategori) {
                    openModalKategori();
                } else {
                    openModalSubKategori();
                }
                setIsButtonLoading(false);
                console.error(error);
            }
        } else {
            try {
                const formData = new FormData();
                formData.append("ukmId", String(ukmIdUser && ukmIdUser[0]));
                formData.append(
                    "file",
                    values.berkas ? (values.berkas as any) : "",
                );
                const { data } = await axios.post<DefaultResponse>(
                    `/api/importsub`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );
                if (data.code === 200) {
                    Swal.fire({
                        title: "Sub kategori berhasil diunggah",
                        position: "top-end",
                        showConfirmButton: false,
                        icon: "success",
                        toast: true,
                        timer: 3000,
                        timerProgressBar: true,
                        showCloseButton: true,
                        customClass: {
                            container: "my-swal",
                        },
                    });
                }
                // openAlert();
                setIsButtonLoading(false);
                setFetchingItems();
                closeModalUnggahKategori();
                if (isKategori) {
                    openModalKategori();
                } else {
                    openModalSubKategori();
                }
                reset(initialValues);
            } catch (error) {
                if (defaultAxios.isAxiosError(error)) {
                    const serverError = error as AxiosError<
                        ErrorFieldResponse | undefined
                    >;
                    if (serverError && serverError?.response) {
                        Swal.fire({
                            title: `${serverError.response.data?.message}`,
                            position: "top-end",
                            showConfirmButton: false,
                            icon: "error",
                            toast: true,
                            timer: 3000,
                            timerProgressBar: true,
                            showCloseButton: true,
                            customClass: {
                                container: "my-swal",
                            },
                        });
                    }
                }
                closeModalUnggahKategori();
                if (isKategori) {
                    openModalKategori();
                } else {
                    openModalSubKategori();
                }
                setIsButtonLoading(false);
                console.error(error);
            }
        }
    };

    return (
        <Dialog
            maxWidth="sm"
            fullScreen={isPhoneScreen}
            fullWidth={true}
            open={isOpenModalUnggahKategori}
            onClose={closeModalUnggahKategori}
            PaperProps={{
                sx: {
                    borderRadius: 1,
                },
            }}
        >
            <DialogTitle>
                <Stack direction="row" spacing={1} alignItems="center">
                    <IconButton
                        onClick={() => {
                            closeModalUnggahKategori();
                            if (isKategori) {
                                openModalKategori();
                            } else {
                                openModalSubKategori();
                            }
                        }}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" fontWeight="bold">
                        Unggah {isKategori ? "Kategori" : "Sub Kategori"}
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Typography variant="h6" fontWeight="bold">
                    Template Pengisian
                </Typography>
                <Typography
                    variant="body1"
                    color="#545E6A"
                    sx={{ maxWidth: "360px" }}
                >
                    Unduh template terlebih dahulu sebelum mengunggah berkas
                </Typography>
                <LoadingButton
                    loading={isButtonTemplateLoading}
                    loadingPosition="center"
                    onClick={() => {
                        if (isKategori) {
                            apiUnduhTemplate();
                        } else {
                            apiUnduhTemplateSubKategori();
                        }
                    }}
                    variant="outlined"
                    size="large"
                    sx={{ marginY: 3 }}
                >
                    Unduh Template
                </LoadingButton>
                <Typography variant="h6" fontWeight="bold">
                    Unggah Berkas
                </Typography>
                <Grid container alignItems="center" marginY={2}>
                    <Grid item xs={12}>
                        <Typography variant="body2" color="#808080">
                            Berkas {isKategori ? "Kategori" : "Sub Kategori"}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Controller
                            name="berkas"
                            control={control}
                            render={({ field }) => (
                                <TextField
                                    id="berkas"
                                    fullWidth
                                    type="file"
                                    variant="outlined"
                                    inputProps={{
                                        accept: ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
                                    }}
                                    error={Boolean(errors.berkas)}
                                    helperText={
                                        errors.berkas
                                            ? errors.berkas.message
                                            : " "
                                    }
                                    {...field}
                                    onChange={(event: any) => {
                                        if (
                                            event.target.files[0].size < 512000
                                        ) {
                                            console.log(event.target.files[0]);
                                            setValue(
                                                "berkas",
                                                event.target.files[0],
                                            );
                                            clearErrors("berkas");
                                        } else {
                                            event.target.value = "";
                                            setError("berkas", {
                                                type: "manual",
                                                message:
                                                    "Ukuran berkas harus kurang dari 500KB",
                                            });
                                        }
                                    }}
                                    value={undefined}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
                <Stack
                    direction="row"
                    spacing={isDesktopScreen ? 0 : 2}
                    alignItems="center"
                >
                    <Button
                        variant="outlined"
                        onClick={() => {
                            closeModalUnggahKategori();
                            if (isKategori) {
                                openModalKategori();
                            } else {
                                openModalSubKategori();
                            }
                        }}
                        fullWidth
                        sx={{ display: { xs: "block", md: "none" } }}
                    >
                        <Typography>Kembali</Typography>
                    </Button>
                    <LoadingButton
                        disabled={!!!ukmIdUser}
                        loading={isButtonLoading}
                        loadingPosition="center"
                        variant="contained"
                        onClick={handleSubmit(onSubmit)}
                        type="submit"
                        fullWidth={isDesktopScreen ? false : true}
                    >
                        Unggah
                    </LoadingButton>
                </Stack>
            </DialogContent>
        </Dialog>
    );
};

export default ModalUnggahKategori;
